var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBurgerMenureact = function SvgBurgerMenureact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "menu",
    transform: "translate(-269 -21)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8897",
    width: 24,
    height: 3,
    rx: 1,
    transform: "translate(269 32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8899",
    width: 24,
    height: 3,
    rx: 1,
    transform: "translate(269 26)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8898",
    width: 24,
    height: 3,
    rx: 1,
    transform: "translate(269 38)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8984",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};

export default SvgBurgerMenureact;